<template>
  <div class="transactions-page-controls">
    <transactions-actions-bar
      :stats="stats"
      :bills="bills"
      :stats-abac="statsAbac"
      :has-stats="hasStats"
      :has-total-stats="hasTotalStats"
      :has-filter="hasFilter"
      :has-export="hasExport"
      :export-options="exportOptions"
      :is-filters-opened="
        showFiltersBlock === true || showFiltersBlockComputed === true
      "
      :is-filter-active="isFilterActive"
      :is-statistic-opened="showStatisticBlock"
      :has-refresh="hasRefresh"
      :specific-actions-to-right="specificActionsToRight"
      @export="handleExport"
      @refresh="handleRefresh"
      @toggleFilters="handleToggleFilters"
      @toggleStatistic="handleToggleStatistic"
    >
      <template #statsBlock>
        <slot name="statsBlock"></slot>
      </template>
      <template #extraFilter>
        <slot name="extraFilter"></slot>
      </template>
      <template #plainFilter>
        <slot name="plainFilter"></slot>
      </template>
      <template #specificActions>
        <slot name="specificActions"></slot>
      </template>
    </transactions-actions-bar>
    <slot name="statisticDetailed" v-if="hasStats && showStatisticBlock">
      <transactions-statistic
        :stats-abac="statsAbac"
        :stats="stats"
        :classList="'transactions-controls__statistic'"
      ></transactions-statistic>
    </slot>
    <transactions-filter
      :is-transactions-loading="isTransactionsLoading"
      :filter-object="filterObject"
      :auto-init-filters="autoInitFilters"
      @filterUpdated="handleFilterChanged"
      @filterReset="handleFilterChanged"
      v-show="showFiltersBlock === true || showFiltersBlockComputed === true"
      :available-filter-types="availableFilterTypes"
      :additional-filters="additionalFilters"
      class="transactions-controls__filters"
    >
    </transactions-filter>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../../utils/gogocodeTransfer'
import { Stats } from '@js-app/entities/transaction/Stats'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
import TransactionsActionsBar from '@vue-app/components/company/transactions/shared/transactions-page-controls/actions-bar/TransactionsActionsBar.vue'
import TransactionsStatistic from '@vue-app/components/company/transactions/shared/transactions-page-controls/statistic/TransactionsStatistic.vue'
import TransactionsFilter from '@vue-app/components/company/transactions/shared/transactions-page-controls/filter/TransactionsFilter.vue'
import { mapState } from 'vuex'

export default {
  name: 'TransactionsPageControls',
  components: {
    TransactionsFilter,
    TransactionsStatistic,
    TransactionsActionsBar,
    RequireAccess,
  },
  props: {
    autoInitFilters: {
      type: Boolean,
      default: false,
    },
    specificActionsToRight: {
      type: Boolean,
      default: false,
    },
    hasTotalStats: {
      type: Boolean,
      default: true,
    },

    bills: {
      type: Boolean,
      default: false,
    },

    stats: {
      type: [Stats, Object],
      default() {
        return new Stats()
      },
    },
    statsAbac: {
      type: Object,
      default() {
        return { data: '', action: '' }
      },
    },
    hasStats: {
      type: Boolean,
      default: true,
    },
    hasFilter: {
      type: Boolean,
      default: true,
    },
    isFilterActive: {
      type: Boolean,
      default: false,
    },
    filterObject: {
      type: Object,
    },
    availableFilterTypes: {
      type: Array,
      default() {
        return []
      },
    },
    additionalFilters: {
      type: Object,
      default() {
        return {}
      },
    },
    hasExport: {
      type: Boolean,
      default: true,
    },
    exportAbac: {
      type: Object,
      default() {
        return { data: '', action: '' }
      },
    },
    exportOptions: {
      type: Array,
      default() {
        return [
          { id: 'csv', name: 'export-action.csv' },
          { id: 'xlsx', name: 'export-action.xlsx' },
        ]
      },
    },
    hasRefresh: {
      type: Boolean,
      default: true,
    },
    isTransactionsLoading: {
      type: Boolean,
      default: false,
    },
    isShowStatisticBlockByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showStatisticBlock: false,
      showFiltersBlock: false,
    }
  },
  created() {
    this.showStatisticBlock = this.isShowStatisticBlockByDefault
  },
  computed: {
    ...mapState(['showFilters']),
    showFiltersBlockComputed() {
      return this.$store.state.showFilters
    },
  },
  methods: {
    handleFilterChanged(filterObject, changeType) {
      $emit(this, 'filterChanged', filterObject, changeType)
    },
    handleExport(exportType) {
      $emit(this, 'export', exportType)
    },
    handleRefresh() {
      $emit(this, 'refresh')
    },

    handleToggleFilters(isFiltersOpened) {
      this.showFiltersBlock = isFiltersOpened

      if (this.showFiltersBlock) {
        this.showStatisticBlock = false
      }

      if (!this.showFiltersBlock) {
        this.$store.dispatch('setShowFilters', false)
      }
    },
    handleToggleStatistic(isStatisticOpened) {
      this.showStatisticBlock = isStatisticOpened

      if (this.showStatisticBlock) {
        this.showFiltersBlock = false
        this.$store.dispatch('setShowFilters', false)
      }
    },
  },
  emits: ['filterChanged', 'export', 'refresh'],
}
</script>

<style lang="scss" scoped>
.transactions-controls {
  :global(.transactions-controls__statistic),
  :global(.transactions-controls__filters) {
    margin-top: 15px;
  }
}
</style>
